export default __webpack_public_path__ + "static/media/logo.8493e988.svg";